import React from 'react'
import '../style/ourcourse.css'

const CourseHome = () => {
    return (
        <>
            <section style={{ textAlign: 'center', marginTop: "50px", marginBottom: "50px", color: 'rgb(13 92 126)' }}>
                <h2>Here’s How Can I Help You?</h2>
            </section>
            <div className='container'>
                <div className='row' style={{ marginTop: '40px' }}>
                    <div className='col' >
                        <div style={{ border: '2px solid rgb(234, 236, 237)', borderRadius: '15px', boxShadow: '2px 2px 4px 4px rgb(234, 236, 237)', textAlign: 'center' }}>
                            <img id='cImgId' src="https://static.vecteezy.com/system/resources/previews/002/730/957/original/coaching-and-mentoring-concept-business-advise-or-consultation-service-businessman-with-personal-mentor-and-business-trainer-discussing-business-strategy-training-courses-vector.jpg" style={{ marginTop: '20px' }} alt="400x400" />
                            <h5 style={{ marginTop: '20px' }}>Strategic Business Consulting Mastery</h5>
                            <p style={{ fontSize: '15px' }}>My 4-hour Webinar that is backed by 10,000+ entrepreneurs and business owners that costs ₹99/-</p>
                            <div>
                                <a href="/ContactUs">
                                    <button type="button" style={{ backgroundColor: 'rgb(13 92 126)', marginTop: '10px', marginBottom: '20px', border: '2px solid rgb(13 92 126)', fontSize: '18px' }} class="btn btn-primary">Contact Us</button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='col' >
                        <div style={{ border: '2px solid rgb(234, 236, 237)', borderRadius: '15px', boxShadow: '2px 2px 4px 4px rgb(234, 236, 237)', textAlign: 'center' }}>
                            <img id='cImgId' src="https://eslbrains.com/wp-content/uploads/2023/01/Does-everyone-need-a-mentor-473x381.png" style={{ marginTop: '20px' }} alt="400x400" />
                            <h5 style={{ marginTop: '20px' }}>Advanced Business Consulting</h5>
                            <p style={{ fontSize: '15px' }}>My 4-hour Webinar that is backed by 10,000+ entrepreneurs and business owners that costs ₹99/-</p>
                            <div>
                                <a href="/ContactUs">
                                    <button type="button" style={{ backgroundColor: 'rgb(13 92 126)', marginTop: '10px', marginBottom: '20px', border: '2px solid rgb(13 92 126)', fontSize: '18px' }} class="btn btn-primary">Contact Us</button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='col' >
                        <div style={{ border: '2px solid rgb(234, 236, 237)', borderRadius: '15px', boxShadow: '2px 2px 4px 4px rgb(234, 236, 237)', textAlign: 'center' }}>
                            <img id='cImgId' src="https://d22bbllmj4tvv8.cloudfront.net/d5/c0/efaeb96d41e3a674f8d2ed576bed/what-is-mentoring1-square.jpg" style={{ marginTop: '20px' }} alt="400x400" />
                            <h5 style={{ marginTop: '20px' }}>Business Consulting</h5>
                            <p style={{ fontSize: '15px' }}>My 4-hour Webinar that is backed by 10,000+ entrepreneurs and business owners that costs ₹99/-</p>
                            <div>
                                <a href="/UmangRataniLandingPage">
                                    <button type="button" style={{ backgroundColor: 'rgb(13 92 126)', marginTop: '10px', marginBottom: '20px', border: '2px solid rgb(13 92 126)', fontSize: '18px' }} class="btn btn-primary">Read More...</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CourseHome
